import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 border-t border-slate-900 py-12 px-4 text-center" data-id="element-60">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-61">
        <span className="font-bold text-xl tracking-tight text-slate-500 mb-6" data-id="element-62">
          EL INTERRUPTOR DE NITRÓGENO
        </span>

        <p className="text-slate-600 text-sm mb-4" data-id="element-63">
          © 2025 Todos los derechos reservados.
        </p>

        <p className="text-slate-700 text-xs max-w-2xl leading-relaxed" data-id="element-64">
          Descargo de responsabilidad: Este producto no sustituye el consejo
          médico profesional. Los resultados pueden variar de persona a persona.
          Consulta a un profesional de la salud ante cualquier condición médica
          antes de comenzar cualquier programa físico.
        </p>
      </div>
    </footer>;
}